
import { Outlet } from "react-router-dom";
import ChatBot from "./ChatBot.js";
import NewChatBot from "./NewChatBot.js";


const WithoutHeaderLayout = () => {
  return (
    <div>
      {/* Only render the child components */}
      {/* <ChatBot /> */}
      {/* <NewChatBot/> */}
      <Outlet />
    </div>
  );
};

export default WithoutHeaderLayout;
